<template>
    <div class="bottom">
       ©2017-{{this.timestamp}}<span class="bottom-span">iblocktech.com</span> 版权所有 <b-link class="beian" target="_blank" href="http://www.miitbeian.gov.cn">粤ICP备18132030号-2</b-link> </span>
    </div>
</template> 

<script>
import moment from "moment"
export default {
  name: "RedDetail",
  components: {},
  props:{
            step:{   //此数据是控制动画快慢的
                type:Number,
                default:120  
            }
        },
  data() {
    return {
      lang:'中文',
      openLang:false,
      isActive:false,
      timestamp: new Date().getTime()

    };
  },
   computed: {
  },
   mounted() {
     this.timestamp= moment(this.timestamp).format("YYYY")
   },
  methods: {

  }
};
</script>
<style  lang="scss"  scoped>
  @import "../../assets/css/Index.scss";  
</style>


// WEBPACK FOOTER //
// src/pages/assembly/Bottom.vue